<script lang="ts">
	import { sharedConfig } from '$lib/animations';
	import { menuContentInOut } from '$lib/animations/MenuTransitions';
	import { Accordion } from '$lib/builders/accordion/Accordion.svelte';
	import type { GlobalSettingsType } from '$lib/queries/GlobalSettingsQuery';
	import ChevronDown from '@icons/ChevronDown.svelte';
	import { Breakpoints } from '@tools';
	import { slide } from 'svelte/transition';

	let {
		data
	}: {
		data: GlobalSettingsType['menus'][0]['columns'];
	} = $props();

	const accordion = Accordion.from(data);
</script>

<section in:menuContentInOut|global out:menuContentInOut|global>
	{#each accordion.items as item}
		<div class:active={item.isActive}>
			{#if Breakpoints.md}
				<h3 class="text:h4">{item.data.title}</h3>
			{:else}
				<button class="text:body" use:item.useTrigger {...item.attrTrigger}>
					<span>{item.data.title}</span>
					<ChevronDown />
				</button>
			{/if}

			{#if item.isActive || Breakpoints.md}
				<ul transition:slide={sharedConfig}>
					{#each item.data.items as link}
						<li>
							<a class="text:body" {...link}>{link.title}</a>
						</li>
					{/each}
				</ul>
			{/if}
		</div>
	{/each}
</section>

<style lang="scss">
	section {
		display: flex;
		flex-direction: column;
		align-items: stretch;
		flex: 1 1 auto;

		@include md {
			flex-grow: 0;
			display: flex;
			flex-direction: row;
			margin-bottom: auto;
			padding: $gap7 var(--gutter);
			gap: var(--gap);
		}

		@include lg {
			padding-left: calc(cols(12, 1, true, true) + (var(--gutter) - var(--gap)));
			padding-right: calc(cols(12, 1, true, true) + (var(--gutter) - var(--gap)));
		}
	}

	div {
		display: flex;
		flex-direction: column;
		align-items: stretch;
		border-bottom: 1px solid $colorBorder;

		&:nth-child(1) {
			border-top: 1px solid $colorBorder;
		}

		&.active {
			background-color: $colorNavBackground;
			color: $colorNavForeground;
		}

		@include md {
			border-bottom: none;
			width: cols(12, 12 * 0.2);

			&:nth-child(1) {
				border-top: none;
			}
		}

		@include lg {
			width: cols(10, 2);
		}
	}

	button {
		display: flex;
		justify-content: space-between;
		align-items: center;
		padding: $gap4 var(--gutter);

		:global(svg) {
			width: 0.625em;
			transition: transform $transition;
		}

		&[aria-expanded='true'] {
			text-decoration: underline;

			:global(svg) {
				transform: rotate(180deg);
			}
		}
	}

	h3 {
		margin-bottom: 1em;
	}

	ul {
		display: flex;
		flex-direction: column;
		align-items: stretch;
		padding-inline-start: 0;
		margin-block: 0;
		list-style-type: none;
		margin-top: calc($gap2 * -1);
		padding-bottom: $gap2;

		@include md {
			margin-top: 0;
			padding-bottom: 0;
		}
	}

	li {
		display: flex;
	}

	a {
		width: 100%;
		padding: $gap2 var(--gutter);
		text-decoration: none;

		@include md {
			padding: 0.2em 0;

			&:hover {
				text-decoration: underline;
			}
		}
	}
</style>
